export const sanitizeNumber = (value, allowFloat = true) => {
	// Step 1: Remove invalid characters
	let sanitized = value.replace(/[^0-9.-]/g, '');

	// Step 2: Keep only the first "-" and only if at start
	sanitized = sanitized.replace(/(?!^)-/g, '');

	// Step 3: If floats are allowed, keep only the first "."
	if (allowFloat) {
		const firstDotIndex = sanitized.indexOf('.');
		if (firstDotIndex !== -1) {
			sanitized = sanitized.slice(0, firstDotIndex + 1) + sanitized.slice(firstDotIndex + 1).replace(/\./g, '');
		}
	} else {
		// Remove all dots if float is not allowed
		sanitized = sanitized.replace(/\./g, '');
	}

	return sanitized;
};
